<template>
    <div>
        <!-- DIALOGS -->
        <SelectionRequiredDialog /> 
		<DeletionDialog :context="'Selected' + context" />

        <BaseListPage
			headline="lang_ERP_PRICELISTS"
            :context="context"
            alvqa="erp-pricelists"
            :stickyHeader="true"
		>
            <template v-slot:dataTable>
                <BaseDataTableList 
                    :headers="headers"
                    :context="context"
                    readOnlyGhostTdSpan="1"
                    alvqa="erp-pricelists"
                    :stickyTopSlot="true"
                >

                    <template v-slot:topSlot> <PricelistsTopSlot /> </template>

                    <!-- <template v-slot:topSlot> <PricelistsTopSlot /> </template>  -->
                    <template v-slot:headers="{ header }">{{ header }}</template>

                    <template v-slot:body="{ item }">

                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="'erp-pricelists-list-row-' + item.item.alvId + '-icon-expand'"
                        />
                        
                        <td class="no_ellipsis" :alvqa="'erp-pricelists-list-row-' + item.item.alvId + '-text-title'">
                            {{ item.item.title }}</td>

                    </template>

                    <template v-slot:expandSlot="{ id }"><PricelistsReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import BaseListPage from '@/components/_base/BaseListPage'
    import BaseDataTableList from '@/components/_base/BaseDataTableList'
    import BaseTooltip from '@/components/_base/BaseTooltip'
    import BaseIcon from '@/components/_buttons/BaseIcon'
    import ExpandIcon from '@/components/_buttons/ExpandIcon'
    import PricelistsReadOnly from './_readonly/PricelistsReadOnly'
    import PricelistsTopSlot from './PricelistsTopSlot'
    import DeletionDialog from '@/components/_dialogs/DeletionDialog'
    import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'

        export default {
            name: 'PricelistsList',						
            components: {
                BaseListPage,
                BaseDataTableList,
                BaseIcon,
                ExpandIcon,
                PricelistsReadOnly,
                PricelistsTopSlot,
                DeletionDialog,
                SelectionRequiredDialog,                
            },
            data() {
                return {
                    context: "Pricelists"
                }
            },

            computed: {
                ...mapGetters(['getPricelistsSearch']),
                headers() {
                    return [
                        { // column 01: Select
                            text: '', 
                            value: 'data-table-select', 
                            width: "60px",
                            sortable: false,
                            class: 'text-no-wrap'
                        },
                        { // column 02: Read-only view
                            text: '', 
                            value: 'data-table-expand',
                            align: 'center', 
                            width: "48px",
                            sortable: false,
                            class: 'text-no-wrap'
                        },
                        { // column 03: Pricelist title
                            text: this.$t('lang_ERP_PRICELISTS_CAPTION_TITLE'), 
                            value: 'title', 
                            align: 'left', 
                            sortable: false,
                            class: 'text-no-wrap'
                        },
                        {
                            text: '', 
                            value: 'editForm',
                            align: 'right',
                            sortable: false,
                            width: "70px",
                            class: 'text-no-wrap'
                        },
                    ]
                }
            }
        }
</script>